import * as React from "react"

export const ScaleIcon: React.FunctionComponent = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.8 11.1V8.4C17.904 7.878 21 5.61 21 3H3C3 5.61 6.096 7.878 10.2 8.4V11.1C6.888 11.757 3 14.349 3 21H8.4V19.2H4.917C5.754 13.053 10.902 12.72 12 12.72C13.098 12.72 18.246 13.053 19.083 19.2H15.6V21H21C21 14.349 17.112 11.757 13.8 11.1ZM18.183 4.8C16.95 5.871 14.7 6.708 12 6.708C9.3 6.708 7.05 5.871 5.817 4.8H18.183ZM12 21C11.01 21 10.2 20.19 10.2 19.2C10.2 18.705 10.398 18.255 10.731 17.931C11.451 17.211 15.6 15.6 15.6 15.6C15.6 15.6 13.989 19.749 13.269 20.469C12.945 20.802 12.495 21 12 21Z"
      fill="#616161"
    />
  </svg>
)
